import axios from 'axios'

export const AdminAdoptionLabelService = {
  /**
   * @param {*} status blank is for both status(published and inactive)
   * status = 1 ==> for inactive
   * status = 2 ==> for published
   */
  fetchAdoptionLabelList (status = '') {
    if (status !== '') {
      return axios.get(`/api/v1/adoplabellist/${status}`)
    } else {
      return axios.get('/api/v1/adoplabellist')
    }
  },
  /**
   * edit record
   */
  editAdoptionLabelItem (data) {
    return axios.post(`/api/v1/editadoplabel`, JSON.stringify({
      adoptionLabel: data.adoptionLabel,
      abbreviation: data.abbreviation,
      adoptionDescriptor: data.adoptionDescriptor,
      status: data.status,
      userId: data.userId,
      id: data.id,
      publisher: data.publisher
    }))
  },
  /**
   * Add record
   */
  addAdoptionLabelItem (data) {
    return axios.post(`/api/v1/addadoplabel`, JSON.stringify({
      adoptionLabel: data.adoptionLabel,
      abbreviation: data.abbreviation,
      adoptionDescriptor: data.adoptionDescriptor,
      status: data.status,
      userId: data.userId,
      publisher: data.publisher
    }))
  },
  validateAdoptionLabelItem (Data) {
    return axios.delete(`/api/v1/deleteadoplabel`, { data: Data })
  },
  deleteAdoptionLabelItem (Data) {
    return axios.delete(`/api/v1/deleteadoplabel`, { data: Data })
  }
}
